<div class="set-route-container">
  <div class="route-info-block">
    <div *ngIf="comment" class="input-field">
      <label>{{ comment }}</label>
    </div>
    <div class="input-field">
      <label>ID <b *ngIf="route.titleEn">({{ route.titleEn }})</b></label>
      <input [(ngModel)]="id">
      <label>Count in one pack</label>
      <input [(ngModel)]="countInOnePack">
    </div>
    <div class="button-container">
      <button (click)="getRoute()">get route</button>
      <button [disabled]="deepEqual(route, initRoute)" (click)="saveRoute()">save route</button>
      <button [disabled]="processed.length == 0" (click)="setProcessed()">upd route</button>
      <button (click)="getUnprocessedRoutes()">get unprocessed routes</button>
      <div *ngIf="!deepEqual(route, initRoute)" style="margin-left: 6px; color: green;">The route has been updated!</div>
    </div>
    <div class="status">
      <div class="status-item" *ngFor="let point of route.points">
        <div *ngIf="point" class="status-item-info">
          <p [innerHTML]="getInfo(point)"></p>
        </div>
      </div>
    </div>
  </div>
  <div class="json-block">
    <div class="json-block-item">
      <div class="json-block-item-title-block">
        <label>For processing</label>
        <button (click)="copyText(forProcessing)">copy</button>
      </div>
      <textarea [(ngModel)]="forProcessing" rows="10" cols="50"></textarea>
    </div>
    <div class="json-block-item">
      <div class="json-block-item-title-block">
        <label>Processed for saving </label>
        <button (click)="pasteText()">paste</button>
      </div>
      <textarea [(ngModel)]="processed"></textarea>
    </div>
  </div>
</div>
